/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetPersonaForWorkspacePickerQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetPersonaForWorkspacePickerQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly createdDate: c.DateTimeString;
    readonly persona: c.Persona | null;
    readonly orgRole: Types.OrgRole;
    readonly interactions: c.PartialUserInteractions;
  } | null;
};

export const GetPersonaForWorkspacePickerDocument = /*#__PURE__*/ gql`
  query GetPersonaForWorkspacePicker {
    me {
      id
      createdDate
      persona
      orgRole
      interactions
    }
  }
`;

/**
 * __useGetPersonaForWorkspacePickerQuery__
 *
 * To run a query within a React component, call `useGetPersonaForWorkspacePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonaForWorkspacePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonaForWorkspacePickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonaForWorkspacePickerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >(GetPersonaForWorkspacePickerDocument, options);
}
export function useGetPersonaForWorkspacePickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >(GetPersonaForWorkspacePickerDocument, options);
}
// @ts-ignore
export function useGetPersonaForWorkspacePickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPersonaForWorkspacePickerQuery,
  GetPersonaForWorkspacePickerQueryVariables
>;
export function useGetPersonaForWorkspacePickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonaForWorkspacePickerQuery,
        GetPersonaForWorkspacePickerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPersonaForWorkspacePickerQuery | undefined,
  GetPersonaForWorkspacePickerQueryVariables
>;
export function useGetPersonaForWorkspacePickerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonaForWorkspacePickerQuery,
        GetPersonaForWorkspacePickerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonaForWorkspacePickerQuery,
    GetPersonaForWorkspacePickerQueryVariables
  >(GetPersonaForWorkspacePickerDocument, options);
}
export type GetPersonaForWorkspacePickerQueryHookResult = ReturnType<
  typeof useGetPersonaForWorkspacePickerQuery
>;
export type GetPersonaForWorkspacePickerLazyQueryHookResult = ReturnType<
  typeof useGetPersonaForWorkspacePickerLazyQuery
>;
export type GetPersonaForWorkspacePickerSuspenseQueryHookResult = ReturnType<
  typeof useGetPersonaForWorkspacePickerSuspenseQuery
>;
export type GetPersonaForWorkspacePickerQueryResult = Apollo.QueryResult<
  GetPersonaForWorkspacePickerQuery,
  GetPersonaForWorkspacePickerQueryVariables
>;
